import styled from "styled-components";
import backgound_image from "../images/background1.jpg";
import {
  FlexContainer,
  Description,
  Title,
} from "../components/CommonComponents";
import { Ellipse, Star } from "../components/svgs";

const Main = styled.div`
  display: flex;
  padding: 0px 10%;
  position: relative;
  top: 80px;
  min-height: max-content; //여기 나중에 손볼 곳.
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
`;

const Interactive = styled.div`
  position: relative;
  top: 100px;
  display: flex;
  min-height: 250px;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  @media (max-width: 1320px) {
    transform: scale(0.8);
  }
  @media (max-width: 600px) {
    font-size: scale(0.6);
  }
  & svg{
    position: relative;
    top: 40px;
  }
  & svg.ellipse{
    position: absolute;
  }
  & svg.star {
    position: relative;
    bottom: 0px;
  }
`;

// const Anchor = styled.div`
//     display: flex;
//     justify-content: center;
//     cursor: pointer;
// `;



function Introduction() {
  return (
    <FlexContainer id="introduction" img={backgound_image} className='page-container'>
      <Main>
        <Title>Multi-Device Bluetooth Video Player</Title>
        <Description>
          Play video on galaxy device at any time. From anywhere. <br />
          Always fast and spend low Energy.
        </Description>
      </Main>
      <Interactive>
      <Ellipse/>
        <Star/>
      </Interactive>
    </FlexContainer>
  );
}

export default Introduction;
